export default {
    REDIRECT: 100,
    LOGOUT: 200,
    CORS: 300,
}